/**
 * 字符串工具类
 * @author frankylli
 */

/**
 * 生成指定位数的随即字符串，可以指定从哪个字符串中获取
 * @param digit 位数
 * @param origin 来源串，随即串中的字符从这里获取
 * @returns {String}
 */
export function randomString(digit, origin) {
  const x = origin || '0123456789qwertyuioplkjhgfdsazxcvbnmABCDEFGHIJKLMNOPQRSTUVWXYZ'
  let tmp = ''
  for (let i = 0; i < digit; i++) {
    tmp += x.charAt(Math.ceil(Math.random() * 100000000) % x.length)
  }
  return tmp
}

export function capitalize(str) {
  if (typeof str === 'string') {
    return str.replace(/^(\w)/, function(value, match) { return match.toUpperCase() })
  } else {
    return str
  }
}

export function idSearchFormatter(value) {
  if (value) {
    const idList = value.match(/\d+/g) || []

    return idList.join(',')
  } else {
    return value
  }
}

/**
 * 返回数字，使之变成带千分位分隔符展示
 * @param {String or Number} strNum 数字或数字字符串
 * @param {String} strNum 分隔符
 * @return {String} 格式化后的数字
 * */
export function formatNum(strNum, sep = ',') {
  return `${strNum}`.replace(/(\d)(?=(?:\d{3})+$)/g, `$1${sep}`)
}

export function formatPercent(strNum, fixedNum = 2) {
  return `${(+strNum * 100).toFixed(fixedNum)}%`
}

/**
  * 转换成热度指数(例如: 播放指数 = (播放量 * (1 + lg(sqrt(播放量) + 1) / 20)) / 455)
  * @param {Number} num 原始值
  * @returns {String} 热度指数
  * */
export function formatHotIndex(num) {
  if (num === 0) {
    return '0'
  }
  // 有可能存在0.00的情况, 代表播放很少, 但并不为0
  return ((num * (1 + Math.log10(Math.sqrt(num) + 1) / 20)) / 455).toFixed(2)
}

// 兆
export const M = Math.pow(10, 12)
// 亿
export const E = Math.pow(10, 8)
// 万
export const W = Math.pow(10, 4)

/**
 * 格式图表坐标轴
 * @param {Number} val
 * @returns {String｜Number} 结果
 */
export function formatAxis(val) {
  if (val >= M) {
    return (val / M).toFixed(0) + 'M'
  } else if (val >= E) {
    return (val / E).toFixed(0) + 'E'
  } else if (val >= W) {
    return (val / W).toFixed(0) + 'W'
  }
  return val
}

export default {
  randomString,
  idSearchFormatter,
  capitalize,
  formatNum,
  formatAxis
}
